import { shootingClearanceGrantedPresenter } from './presenters/shootingClearanceGranted';
import { shootingClearanceRevokedPresenter } from './presenters/shootingClearanceRevoked';

export const SHOOTING_CLEARANCE_ME_REFETCH_NOTIFICATION_TYPES = new Set([
  shootingClearanceGrantedPresenter.type,
  shootingClearanceRevokedPresenter.type,
]);
